module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/banner/intro-video-vp9-500k-ef71b8155d25fc2baec9068f680f2954.webm";